import { render, staticRenderFns } from "./PushPreview.vue?vue&type=template&id=0cc923c2&scoped=true&"
import script from "./PushPreview.vue?vue&type=script&lang=js&"
export * from "./PushPreview.vue?vue&type=script&lang=js&"
import style0 from "./PushPreview.vue?vue&type=style&index=0&id=0cc923c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc923c2",
  null
  
)

export default component.exports